export default __webpack_public_path__ + "locales/fi/Common.json?hash=dbc1b3d96cf80c5f117efeef1b2621f7";